<template>
  <ul class="prof-info">
    <li v-if="councilLabel">
      <i class="fas fa-id-card"></i>
      <div>
        <span class="prof-info__label">Conselho</span>
        <span>{{ councilLabel }}</span>
      </div>
    </li>
    <li v-if="professional.place_name">
      <i class="fas fa-clinic-medical"></i>
      <div>
        <span class="prof-info__label">Local</span>
        <span>{{ professional.place_name }}</span>
      </div>
    </li>
    <li v-if="professional.place_address && professional.show_address">
      <i class="fas fa-map-marker-alt"></i>
      <div>
        <span class="prof-info__label">Endereço</span>
        <span>
          {{ professional.place_address }}, {{ professional.place_addr_numer }}
          <template v-if="professional.place_neighborhood"> — {{ professional.place_neighborhood }}</template>
          <template v-if="professional.city_name">
            <br>{{ professional.city_name }}/{{ professional.state_initials }}
          </template>
        </span>
      </div>
    </li>
    <li v-if="professional.show_phone && (professional.prof_phone || professional.place_phone)">
      <i class="fas fa-phone-alt"></i>
      <div>
        <span class="prof-info__label">Telefone</span>
        <span>
          <a v-if="professional.prof_phone" :href="'tel:' + professional.prof_phone">
            {{ professional.prof_phone }}
          </a>
          <a
            v-if="professional.place_phone && professional.prof_phone != professional.place_phone"
            class="ms-2"
            :href="'tel:' + professional.place_phone"
          >
            {{ professional.place_phone }}
          </a>
        </span>
      </div>
    </li>
    <li v-if="professional.patient_age_desc != null">
      <i class="fas fa-user-clock"></i>
      <div>
        <span class="prof-info__label">Faixa etária</span>
        <span>{{ professional.patient_age_desc }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ProfessionalInfo",
  props: {
    professional: {
      type: Object,
      required: true,
    },
    councilLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.prof-info {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.prof-info li {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid color-mix(in srgb, var(--place-color) 14%, #f0e6ec);
  color: #3d2c38;
}

.prof-info i {
  width: 18px;
  margin-top: 4px;
  color: var(--place-color);
}

.prof-info__label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8a7482;
  margin-bottom: 2px;
}
</style>
